import { MessageDetailPage } from './pages/MessageDetail.page'
import { MessageRootPage } from './pages/MessageRoot.page'

import type { RouteObject } from 'react-router-dom'

const messageRoutes: RouteObject[] = [
  {
    path: 'message',
    element: <MessageRootPage />,
    children: [
      {
        path: ':id',
        element: <MessageDetailPage />,
      },
    ],
  },
]

export { messageRoutes }
